export default __webpack_public_path__ + "static/media/su.6714b16d.svg";